<template>
  <div class="lista-preguntas-container">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
      <h3 style="margin: 0;">Preguntas del Bot ({{ preguntas.length }})</h3>
      <div>
        <button @click="refrescarLista" class="btn btn-secondary" :disabled="refrescando" style="margin-right: 10px;">
          🔄 {{ refrescando ? 'Refrescando...' : 'Refrescar' }}
        </button>
        <button @click="crearNuevaPregunta" class="btn btn-primary">
          ➕ Nueva Pregunta
        </button>
      </div>
    </div>
    
    <!-- 🆕 Indicador de carga -->
    <div v-if="refrescando" class="loading-indicator">
      <div class="spinner-border spinner-border-sm" role="status"></div>
      <span>Cargando preguntas...</span>
    </div>
    
    <div v-if="preguntas.length === 0 && !refrescando" class="alert alert-info">
      <strong>ℹ️ Sin preguntas configuradas</strong>
      <br>Este requerimiento aún no tiene preguntas del bot.
      <br><button @click="crearNuevaPregunta" class="btn btn-primary" style="margin-top: 0.5rem;">
        ➕ Crear Primera Pregunta
      </button>
    </div>
    
    <!-- 🆕 Añadir data-pregunta-id para poder hacer scroll -->
    <div 
      v-for="pregunta in preguntas" 
      :key="pregunta.id_pregunta_unico || pregunta.id_pregunta" 
      class="pregunta-card"
      :data-pregunta-id="pregunta.id_pregunta || pregunta.id"
      :id="pregunta.domId"
    >
      <div class="pregunta-header">
        <div class="pregunta-info">
          <strong class="orden-badge">Orden {{ pregunta.orden }}</strong>
          <span class="badge-empresa" :class="getClaseEmpresa(pregunta)">
            {{ getNombreEmpresa(pregunta) }}
          </span>
          <!-- 🆕 Indicador de pregunta recién actualizada -->
          <span v-if="pregunta.recientementeActualizada" class="badge-actualizada">
            🆕 Actualizada
          </span>
        </div>
        <div class="pregunta-acciones">
          <button @click="editarPregunta(pregunta)" class="btn-accion btn-editar" title="Editar">
            ✏️
          </button>
          <button @click="confirmarEliminar(pregunta)" class="btn-accion btn-eliminar" title="Eliminar">
            🗑️
          </button>
        </div>
      </div>
      <div class="pregunta-contenido">
        <div class="pregunta-texto">{{ pregunta.pregunta }}</div>
        <div class="pregunta-detalles">
          <span><strong>Tipo:</strong> {{ getTipoLabel(pregunta.tipo_pregunta) }}</span>
          <span><strong>Respuesta:</strong> {{ getTipoRespuestaLabel(pregunta.tipo_respuesta) }}</span>
          <span><strong>Acción:</strong> {{ getAccionLabel(pregunta.accion_siguiente) }}</span>
          <span v-if="pregunta.es_obligatoria"><strong>Obligatoria:</strong> Sí</span>
        </div>
        <div v-if="pregunta.mensaje_escalado" class="mensaje-escalado">
          <strong>Mensaje de escalado:</strong> {{ pregunta.mensaje_escalado }}
        </div>
        <div v-if="pregunta.empresa_origen" class="info-origen">
          <small>ID único: {{ pregunta.id_pregunta_unico || pregunta.id_pregunta }}</small>
          <!-- 🆕 Mostrar última actualización -->
          <small v-if="pregunta.fecha_actualizacion" style="margin-left: 10px;">
            📅 {{ formatFecha(pregunta.fecha_actualizacion) }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListaPreguntas',
  props: {
    preguntas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      refrescando: false
    }
  },
  watch: {
    // 🆕 Watch para detectar cambios en las preguntas
    preguntas: {
      handler(newPreguntas) {
        console.log('🔄 ListaPreguntas: preguntas actualizadas', newPreguntas.length);
        // Puedes añadir efectos visuales aquí
      },
      deep: true
    }
  },
  methods: {
    // 🆕 Método para refrescar manualmente
    refrescarLista() {
      this.refrescando = true;
      this.$emit('refrescar-preguntas');
      
      // Auto-reset después de 2 segundos
      setTimeout(() => {
        this.refrescando = false;
      }, 2000);
    },
    
    formatFecha(fechaString) {
      if (!fechaString) return '';
      const fecha = new Date(fechaString);
      return fecha.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    
getClaseEmpresa(pregunta) {
  console.log("🎨 getClaseEmpresa - pregunta recibida:", pregunta);
  console.log("   - idEmpresa:", pregunta.idEmpresa);
  console.log("   - empresaNombre:", pregunta.empresaNombre);
  console.log("   - empresa_origen:", pregunta.empresa_origen);
  console.log("   - id_empresa_origen:", pregunta.id_empresa_origen);
  
  // 🔥 PRIORIDAD 1: Usar idEmpresa (con E mayúscula)
  if (pregunta.idEmpresa === 1 || pregunta.idEmpresa === 2) {
    return pregunta.idEmpresa === 1 ? 'empresa-facilisimo' : 'empresa-apostar';
  }
  
  // 🔥 PRIORIDAD 2: Usar empresaNombre
  if (pregunta.empresaNombre) {
    return pregunta.empresaNombre.toLowerCase().includes('facilisimo') ? 'empresa-facilisimo' : 'empresa-apostar';
  }
  
  // 🔥 PRIORIDAD 3: Campos legacy (por compatibilidad)
  const origen = pregunta.empresa_origen || (pregunta.id_empresa_origen === 1 ? 'facilisimo' : 'apostar');
  return origen === 'facilisimo' ? 'empresa-facilisimo' : 'empresa-apostar';
},

getNombreEmpresa(pregunta) {
  console.log("🏷️ getNombreEmpresa - pregunta recibida:", pregunta);
  
  // 🔥 PRIORIDAD 1: Usar idEmpresa (con E mayúscula)
  if (pregunta.idEmpresa === 1 || pregunta.idEmpresa === 2) {
    return pregunta.idEmpresa === 1 ? 'Facilisimo' : 'Apostar';
  }
  
  // 🔥 PRIORIDAD 2: Usar empresaNombre
  if (pregunta.empresaNombre) {
    return pregunta.empresaNombre;
  }
  
  // 🔥 PRIORIDAD 3: Campos legacy (por compatibilidad)
  const origen = pregunta.empresa_origen || (pregunta.id_empresa_origen === 1 ? 'facilisimo' : 'apostar');
  return origen === 'facilisimo' ? 'Facilisimo' : 'Apostar';
},
    
    getTipoLabel(tipo) {
      const tipos = {
        1: 'Pregunta Normal',
        2: 'Mensaje de Inicio', 
        3: 'Acción Intermedia',
        4: 'Mensaje Final'
      }
      return tipos[tipo] || 'Desconocido'
    },
    
    getTipoRespuestaLabel(tipo) {
      const tipos = {
        1: 'Texto Libre',
        2: 'Solo Números',
        3: 'Cédula',
        4: 'Teléfono', 
        5: 'Archivo/Imagen',
        6: 'Sí/No'
      }
      return tipos[tipo] || 'Desconocido'
    },
    
    getAccionLabel(accion) {
      const acciones = {
        1: 'Continuar',
        2: 'Escalar',
        3: 'Cerrar Resuelto',
        4: 'Solicitar Mensaje'
      }
      return acciones[accion] || `Acción ${accion}`
    },
    
    crearNuevaPregunta() {
      this.$emit('crear-pregunta')
    },
    
    editarPregunta(pregunta) {
      this.$emit('editar-pregunta', pregunta)
    },
    
    confirmarEliminar(pregunta) {
      this.$emit('confirmar-eliminar', pregunta)
    }
  }
}
</script>

<style scoped>
/* 🆕 ESTILOS PARA BADGE DE EMPRESA */
.badge-empresa {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
  margin-left: 8px;
  display: inline-block;
}

.empresa-facilisimo {
  background-color: #2196F3; /* Azul para Facilisimo */
  color: white;
}

.empresa-apostar {
  background-color: #4CAF50; /* Verde para Apostar */
  color: white;
}

/* Estilo para información de origen */
.info-origen {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #eee;
  font-size: 12px;
  color: #666;
}

/* Estilos existentes (mantener) */
.pregunta-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.pregunta-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.pregunta-info {
  display: flex;
  align-items: center;
}

.orden-badge {
  background: #007bff;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.pregunta-acciones {
  display: flex;
  gap: 8px;
}

.btn-accion {
  background: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 14px;
}

.btn-editar:hover {
  background: #e7f3ff;
  border-color: #007bff;
}

.btn-eliminar:hover {
  background: #ffeaea;
  border-color: #dc3545;
}

.pregunta-texto {
  font-size: 14px;
  margin-bottom: 0.75rem;
  line-height: 1.4;
}

.pregunta-detalles {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12px;
  color: #666;
}

.pregunta-detalles span {
  display: inline-block;
}

.mensaje-escalado {
  margin-top: 0.5rem;
  padding: 0.5rem;
  background: #fff8e1;
  border-radius: 4px;
  font-size: 12px;
}
</style>
